import { render, staticRenderFns } from "./DeliveryReadOnly.vue?vue&type=template&id=4d87970a&"
import script from "./DeliveryReadOnly.vue?vue&type=script&lang=js&"
export * from "./DeliveryReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports